import PlaceThread from './PlaceThread'
import PlaceThreadContianer from './PlaceThreadContainer'

export default PlaceThreadContianer(PlaceThread)
